import { ANALYTICS_SEGMENT, ANALYTICS_SESSION_ID_STORAGE_KEY } from 'Constants/analytics';
import segmentClient from 'Utilities/analytics/segmentClient';
import { getAppVersion } from 'Utilities/dataHelpers';
import { store } from 'Utilities/store';
let _analyticsClient;
const getSessionId = () => {
  let sessionId = sessionStorage.getItem(ANALYTICS_SESSION_ID_STORAGE_KEY);
  if (sessionId) {
    return sessionId;
  }
  sessionId = crypto.randomUUID();
  sessionStorage.setItem(ANALYTICS_SESSION_ID_STORAGE_KEY, sessionId);
  return sessionId;
};
export const initialize = config => {
  if (!config || config.driver === '' || config.driver === 'none') {
    return;
  }
  const analyticsType = config.driver;
  if (analyticsType === ANALYTICS_SEGMENT) {
    _analyticsClient = segmentClient;
    _analyticsClient.initialize(config.configuration);
  }
};
export const track = (event, properties) => {
  const {
    auth: {
      user
    }
  } = store.getState();
  const sessionId = getSessionId();
  const {
    build,
    version
  } = getAppVersion();
  const userRegion = ''; // TODO handle it once api return the region in the config
  const userCountry = user.country;
  const userLanguage = user.uiLanguage;
  _analyticsClient?.track(event, {
    sessionId,
    build,
    version,
    userRegion,
    userCountry,
    userLanguage,
    ...properties
  });
};
export const identify = userId => {
  _analyticsClient?.identify(userId);
};